const br_isEnabled = () => {
  return window._THULEDATA?.Bloomreach?.IsEnabled === true;
};

const br_hasCookiebotMarketingConsent = () => {
  return window.Cookiebot?.consent?.marketing === true;
};

const br_trackingEnabled = () => {
  return (
    window._THULEDATA?.Bloomreach?.IsEnabled === true &&
    br_hasCookiebotMarketingConsent() &&
    typeof exponea !== 'undefined'
  );
};

const br_identify = (email) => {
  if (!br_trackingEnabled() || !email) return;

  exponea.identify({
    email_id: email,
  });

  const culture = _THULEDATA.SitecoreLanguage?.split('-');
  const language = culture[0];
  const market = culture[1];

  getHashedEmail(email).then((hash) => {
    exponea.update({ email, market, language, hashed_email: hash || '' });
  });
};

async function getHashedEmail(email) {
  if (email == null || (typeof email === 'string' && email.trim() === '')) return null;
  try {
    const normalized = email.toLowerCase();
    const encoder = new TextEncoder();
    const data = encoder.encode(normalized);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = new Uint8Array(hashBuffer);
    const hex = Array.from(hashArray)
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
    return hex;
  } catch {
    return null;
  }
}

export { br_identify, br_trackingEnabled, br_isEnabled, getHashedEmail };
